import React, { ReactElement } from 'react';
import { __, Message } from 'first-intl';
import { WsAddress } from '../../../ws/result/WsAddress';

const _AddressBox = {
    renderName: (address: WsAddress): ReactElement | string => {
        const { lastName, salutation, firstName, companyName } = address;
        if (address.isCompanyAddress()) {
            if (firstName || lastName) {
                return (
                    <>
                        {companyName}
                        <br />
                        {firstName} {lastName}
                    </>
                );
            } else {
                return <>{companyName}</>;
            }
        } else {
            const salutationMessage: Message | undefined = salutation.message;
            return (
                <>
                    {salutationMessage && <>{__(salutationMessage)} </>}
                    {firstName && <span>{firstName + ' '}</span>}
                    {lastName}
                </>
            );
        }
    },
};

export type AddressBoxProps = { address: WsAddress };

export const AddressBox: React.FC<AddressBoxProps> = ({ address }) => {
    const { street, houseNumber, zipCode, city, addition } = address;
    return (
        <>
            {__(address.isCompanyAddress() ? 'address.description.company' : 'address.description.private')}
            <br />
            {_AddressBox.renderName(address)}
            <br />
            {street && (
                <>
                    {street}
                    {houseNumber && <span>{' ' + houseNumber}</span>}
                    <br />
                </>
            )}
            {addition && (
                <>
                    {addition}
                    <br />
                </>
            )}
            {zipCode}
            {' ' + city}
        </>
    );
};
